export const CONTROL = 'control';

export const JF_VERTICAL_STACK = 'experiment-jf-vertical-stack';

export const EXPERIMENT_JF_HIDE_PAGINATION = 'experiment-jf-hide-pagination';

// Upcycle gift kit modal experiment
export const EXPERIMENT_UPCYCLE_MODAL_ADD_GIFT_KIT =
  'upcycle-modal-add-gift-kit';
export const prepKitAmplitudeVariantName = 'automatic 2mo reminder';
export const prepKitAmplitudeControlName = 'control';

// Truemed Payments Experiment
export const EXPERIMENT_TRUEDMED_PAYMENTS = 'exp-truemed-payments-v2';

// Stripe Link Payment Method Config Experiment
export const STRIPE_LINK_EXPERIMENT = 'experiment-jf-link';

// Trial Authorization Hold Experiment
export const EXPERIMENT_JF_TRIAL_AUTHORIZATION_HOLD =
  'experiment-trial-auth-hold';
export const JF_TRIAL_AUTHORIZATION_HOLD_VARIANT = 'experiment';

export const EXPERIMENT_JF_BNPL_EXPOSURE = 'experiment-jf-bnpl-exposure';
export const BNPL_EXPOSURE_CART_UPSELL = 'bnpl-24m-cart-upsell';
export const BNPL_EXPOSURE_PLAN_PAGE = 'bnpl-24m-on-plan-page';
export const BNPL_CONTROL = 'control';
